export default "__VITE_ASSET__3327c3cd__"